export default "__VITE_ASSET__AqUPqqWA__"